import { render, staticRenderFns } from "./addPamseMange.vue?vue&type=template&id=44b12a6f&"
import script from "./addPamseMange.vue?vue&type=script&lang=js&"
export * from "./addPamseMange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44b12a6f')) {
      api.createRecord('44b12a6f', component.options)
    } else {
      api.reload('44b12a6f', component.options)
    }
    module.hot.accept("./addPamseMange.vue?vue&type=template&id=44b12a6f&", function () {
      api.rerender('44b12a6f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/components/addPamseMange.vue"
export default component.exports